import { VehicleEquipmentIcons } from '@/components/controls';
import {
  getStatusColor,
  getStatusForeColor,
  kilometresToMiles,
  startCase,
} from '@/utils';
import { useDallasKeys } from '@/utils/config';
import {
  DirectionsCar as DirectionsCarIcon,
  Key as KeyIcon,
  Nfc as NfcIcon,
  Router as RouterIcon,
} from '@mui/icons-material';
import {
  Avatar,
  Badge,
  Chip,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';

export function VehicleListItem({
  item: { size, start },
  feature,
  selected,
  ...props
}) {
  const primary =
    feature.properties.vehicle?.registrationNumber ?? feature.properties.imei;
  const secondary =
    feature.properties?.vehicle?.fleetNumber ?? 'Unassigned box';

  return (
    <ListItem
      {...props}
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: `${size}px`,
        transform: `translateY(${start}px)`,
      }}
      // secondaryAction={
      //   <Tooltip title="Follow">
      //     <IconButton
      //       // component={Link}
      //       // to={`${featureCollections[type][index].code}?copy=true`}
      //       state={{ copy: true }}
      //       size="small"
      //       edge="end"
      //     >
      //       <GpsFixedIcon fontSize="inherit" />
      //     </IconButton>
      //   </Tooltip>
      // }
      disablePadding
    >
      <ListItemButton
        dense
        // component={Link}
        // to={'.'}
        selected={selected}
      >
        <ListItemAvatar>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={
              feature.properties?.driver?.code ? (
                <Tooltip
                  title={
                    feature.properties?.driver?.collarNumber ??
                    feature.properties?.driver?.code
                  }
                  placement="right"
                >
                  <Avatar
                    sx={(theme) => ({
                      width: 22,
                      height: 22,
                      border: `2px solid ${theme.palette.background.paper}`,
                      bgcolor: '#000',
                    })}
                  />
                </Tooltip>
              ) : feature.properties?.rfidCard ? (
                <Tooltip
                  title={
                    feature.properties?.rfidCard.label ??
                    feature.properties?.rfidCard.reference
                  }
                  placement="right"
                >
                  <Avatar
                    sx={(theme) => ({
                      width: 22,
                      height: 22,
                      border: `2px solid ${theme.palette.background.paper}`,
                    })}
                  >
                    {useDallasKeys ? (
                      <KeyIcon sx={{ fontSize: 12 }} />
                    ) : (
                      <NfcIcon sx={{ fontSize: 12 }} />
                    )}
                  </Avatar>
                </Tooltip>
              ) : undefined
            }
          >
            <Tooltip
              title={startCase(feature.properties?.status)}
              placement="top"
            >
              <Avatar
                sx={{
                  color: getStatusForeColor(feature.properties?.status),
                  bgcolor: getStatusColor(feature.properties?.status),
                  borderColor: getStatusForeColor(feature.properties?.status),
                  borderWidth: 2,
                  borderStyle: 'solid',
                }}
              >
                {feature.properties?.vehicle?.identificationNumber ? (
                  <DirectionsCarIcon />
                ) : (
                  <RouterIcon />
                )}
              </Avatar>
            </Tooltip>
          </Badge>
        </ListItemAvatar>
        <ListItemText
          primary={primary}
          secondary={secondary}
          slotProps={{
            primary: { noWrap: true },
            secondary: { noWrap: true },
          }}
        />
        <VehicleEquipmentIcons
          properties={feature.properties}
          sx={{ pr: 0.5 }}
        />
        <Chip
          size="small"
          label={`${kilometresToMiles(
            feature.properties?.speedKilometresPerHour,
          )} MPH`}
          sx={{ fontSize: '.6rem', height: 18 }}
        />
      </ListItemButton>
    </ListItem>
  );
}
